import App from "./App.vue";
import {  createApp } from "vue";
import router from "@/router";
import { VueWindowSizePlugin, vueWindowSizeAPI } from 'vue-window-size/plugin';
import axios from 'axios'
import VueAxios from 'vue-axios'
import WaveUI from "wave-ui";
import "wave-ui/dist/wave-ui.css";
import AddToHomescreen from '@owliehq/vue-addtohomescreen';
import './registerServiceWorker'


// const cspNonce = process.env.VUE_APP_CSP_NONCE || 'static-2026-zcs-portal';
// loadAPP();
const app = createApp(App)

new WaveUI(app, {
});
app.use(router);
app.use(VueAxios, axios)
app.use(VueWindowSizePlugin,vueWindowSizeAPI)
app.use(AddToHomescreen, {
  buttonColor: '#34558B',
  iconPath:'favicon-zcs.png'
});
app.mount("#app");


// async function loadAPP() {
//   if (window.loadPortalSettings) {
//     await new Promise((resolve, reject) => {
//       const script = document.createElement('script');
//       script.src = '../public/cfg/settings.js' + '?v=' + Date.now();
//       script.async = false;
//       script.defer = true;
  
//         script.onload = () => {
//           if (!window.__env || !window.__env.defaults) {
//             reject(new Error('__env.defaults not defined'));
//           } else {
//             resolve();
//           }
//         };
  
//         script.onerror = () => reject(new Error('Failed to load settings.js'));
//       document.head.appendChild(script);
//     });
//   }

//   const app = createApp(App);
//   new WaveUI(app, {
//     styleOptions: {
//       nonce: cspNonce, // Add nonce to WaveUI styles
//     },
//   });
//   app.use(router);
//   app.use(VueAxios, axios)
//   app.use(VueWindowSizePlugin,vueWindowSizeAPI)
//   app.use(AddToHomescreen, {
//     buttonColor: '#34558B',
//     iconPath:'favicon-zcs.png'
//   });

//   app.mount('#app');
// }
